<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        v-if="view === 'table1'"
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      />
      <div style="overflow: hidden;">
        <apexchart
          v-show="view === 'graph1'"
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>

    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'HourlyDynamics',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headers: [
          {text: 'Время', value: 'labels'},
          {text: 'Всего вызовов', value: 'total_calls_count'},
          {text: 'Количество принятых', value: 'accepted_calls_count'},
          {text: 'Количество пропущенных', value: 'missed_calls_count'},
          {text: 'Количество пропущенных с ожиданием < 10сек.', value: 'missed_calls_count_less_wait_time'},
          {text: 'Количество пропущенных с ожиданием > 10сек.', value: 'missed_calls_count_more_wait_time'},
        ],
      },

      series: [
        {
          name: 'Принятые',
          data: [],
        },
        {
          name: 'Пропущенные менее порогового',
          data: [],
        },
        {
          name: 'Пропущенные более порогового',
          data: [],
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          background: '#00000000'
        },
        legend: {
          show: false,
        },
        colors: [
          '#4CAF50',
          '#FF9800',
          '#F44336',
        ],
        theme: {
          mode: 'light'
        },
        fill: {
          opacity: 1
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          tickAmount: 5
        },
      },
    }
  },

  computed: {
    ...mapGetters({}),

    isDarkTheme() {
      return this.$vuetify.theme.isDark
    },
  },

  watch: {
    isDarkTheme() {
      this.changeApexTheme()
    },
  },

  methods: {
    ...mapActions({
      loadHourlyDynamicsWidget: 'dashboard/loadHourlyDynamicsWidget',
    }),

    async loadData() {
      this.isLoaded = false
      const rawData = await this.loadHourlyDynamicsWidget(this.widget.params)

      const preparedItems = []
      if ('labels' in rawData) {
        const len = rawData.labels.length

        for (let i = 0; i < len; i++) {
          const item = {}
          for (const key in rawData) {
            item[key] = rawData[key][i]
          }
          preparedItems.push(item)
        }
      }

      this.fillItemsForApex(rawData)

      this.table.items = preparedItems
    },

    fillItemsForApex(items) {
      this.isLoaded = false

      setTimeout(() => {
        this.chartOptions.xaxis.categories = items.labels
  
        this.series[0].data = items.accepted_calls_count
        this.series[1].data = items.missed_calls_count_less_wait_time
        this.series[2].data = items.missed_calls_count_more_wait_time
  
        this.isLoaded = true
      }, 500)
    },

    changeApexTheme() {
      this.isLoaded = false

      setTimeout(() => {
        if (this.isDarkTheme) {
          this.chartOptions.chart.background = '#00000000'
          this.chartOptions.theme.mode = 'dark'
        } else {
          this.chartOptions.chart.background = '#00000000'
          this.chartOptions.theme.mode = 'light'
        }
        this.isLoaded = true
      }, 10)
    },
  },
  
  mounted() {
    this.changeApexTheme()

    this.loadData()
  },
}
</script>


<style scoped lang="scss">
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 120px;
    width: 100%;
  }

  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>